export enum IJobStatus {
  pending = 'pending',
  completed = 'completed',
  errored = 'errored',
}

export default IJobStatus;
